var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcMultiselect',{staticClass:"group-multiselect",attrs:{"placeholder":_vm.t('settings', 'None'),"track-by":"gid","label":"displayName","options":_vm.availableGroups,"open-direction":"bottom","multiple":true,"allow-empty":true},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }